<template>
  <div v-if="show" class="add-video-box" :class="show ? 'show' : ''">
    <div class="title">
      <i class="el-icon-back" @click="close">&nbsp;返回</i>
      <span>新增视频</span>
    </div>
    <div>
      <el-form ref="form" :model="form" :rules="rules" label-width="100px">
        <el-form-item label="封面上传:" prop="cover">
          <base-upload
            :cover="form.cover"
            :key="form.coverImg"
            :action="actionPics"
            @successCallback="successCallback"
            @changeImgUrl="changeImgUrl"
            :id="form.sourceID"
            :wSize="360"
            :hSize="640"
            :width="'120px'"
            :height="'213px'"
          ></base-upload>
        </el-form-item>
        <div class="flex-item">
          <el-form-item label="上传类型:" prop="newsType">
            <el-select
              v-model="form.newsType"
              size="small"
              placeholder="请选择上传类型"
              clearable
            >
              <el-option value="SP" label="短视频"></el-option>
              <el-option value="COVER" label="图集"></el-option>
              <!-- <el-option value="AD_SP" label="视频广告"></el-option> -->
              <!-- <el-option value="AD_COVER" label="图片广告"></el-option> -->
            </el-select>
          </el-form-item>
          <el-form-item label="主题模块:" prop="subModuleID">
            <div style="display: flex">
              <div style="height: 32px">
                <el-cascader
                  :options="secondModuleList"
                  style="width: 100%"
                  v-model="form.subModuleID"
                  :show-all-levels="false"
                  :props="{ emitPath: false, expandTrigger: 'hover' }"
                  @change="handleChangeModule"
                  clearable
                ></el-cascader>
              </div>
            </div>
          </el-form-item>
        </div>

        <div class="flex-item">
          <el-form-item
            label="上传视频:"
            v-if="form.newsType === 'SP' || form.newsType === 'AD_SP'"
          >
            <!--视频分片上传-->
            <uploader
              :options="options"
              class="uploader-example"
              ref="uploader"
              @file-added="fileAdd"
              @file-success="onFileSuccess"
            >
              <uploader-unsupport></uploader-unsupport>
              <uploader-drop>
                <uploader-btn :attrs="attrs">上传视频</uploader-btn>
              </uploader-drop>
              <uploader-list style="width: 680px"></uploader-list>
            </uploader>
          </el-form-item>
          <!-- <el-form-item
            label="封面上传1:"
            prop="seriesCover"
            v-if="
              (form.newsType === 'SP' || form.newsType === 'AD_SP') &&
              form.sourceURL
            "
          >
            <base-upload
              :cover="form.seriesCover"
              :action="action"
              @successCallback="successCallback"
              :id="form.sourceID"
              :wSize="360"
              :hSize="640"
              :width="'120px'"
              :height="'213px'"
            ></base-upload>
          </el-form-item> -->
        </div>
        <div class="flex-item">
          <el-form-item
            style="width: 1100px"
            label="上传图集:"
            prop="cover"
            v-if="
              form.newsType === 'COVER' ||
              form.newsType === 'SP' ||
              form.newsType === 'AD_SP'
            "
          >
            <!--上传图集-->
            <imgs-upload
              :cover="form.seriesCover"
              :action="actionPics"
              @successCallback="successCallbackPic"
              :id="form.sourceID"
              :wSize="180"
              :hSize="320"
              :width="'100px'"
              :height="'100px'"
            ></imgs-upload>
          </el-form-item>
        </div>
        <div class="flex-item">
          <el-form-item label="视频标题:" prop="title">
            <el-input v-model="form.title" size="small"></el-input>
          </el-form-item>
          <el-form-item label="免费时长:" prop="freeTime">
            <el-input v-model.number="form.freeTime" size="small"></el-input>
          </el-form-item>
          <el-form-item label="免费专区:" prop="freeArea">
            <div style="width: 240px">
              <el-radio v-model="form.freeArea" :label="Boolean(true)"
                >是</el-radio
              >
              <el-radio v-model="form.freeArea" :label="Boolean(false)"
                >否</el-radio
              >
            </div>
          </el-form-item>
          <el-form-item
            label="帖子定价:"
            prop="coins"
            v-if="form.newsType === 'SP' || form.newsType === 'COVER'"
          >
            <el-input
              v-model.number="form.coins"
              size="small"
              @input="changeInput()"
            ></el-input>
          </el-form-item>
          <el-form-item v-else></el-form-item>
        </div>
        <div class="flex-item">
          <el-form-item label="城市填写:" prop="location.city">
            <el-input v-model="form.location.city" size="small"></el-input>
          </el-form-item>
          <el-form-item label="用户ID:" prop="uid" flex="1">
            <el-input
              v-model.number="form.uid"
              size="small"
              placeholder="请输入用户ID"
            ></el-input>
          </el-form-item>
          <el-form-item label="广告排序号:" prop="sortCode">
            <el-input v-model.number="form.sortCode" size="small"></el-input>
          </el-form-item>
          <!-- <el-form-item label="是否免费:">
            <el-switch v-model="isFree" disabled></el-switch>
          </el-form-item>-->
        </div>
        <div
          class="flex-item"
          v-if="form.newsType === 'SP' || form.newsType === 'AD_SP'"
        >
          <el-form-item label="影片类型:" prop="mimeType">
            <el-input v-model="form.mimeType" size="small"></el-input>
          </el-form-item>
          <el-form-item label="视频时长:" prop="playTime">
            <el-input v-model="form.playTime" size="small"></el-input>
          </el-form-item>
          <el-form-item label="视频来源:" prop="via">
            <el-input v-model="form.via" size="small"></el-input>
          </el-form-item>
        </div>
        <div
          class="flex-item"
          v-if="form.newsType === 'SP' || form.newsType === 'AD_SP'"
        >
          <el-form-item label="文件名:" prop="filename">
            <el-input v-model="form.filename" size="small"></el-input>
          </el-form-item>
          <el-form-item label="分辨率:" prop="resolution">
            <el-input v-model="form.resolution" size="small"></el-input>
          </el-form-item>
          <el-form-item label="文件大小:" prop="size">
            <el-input v-model="form.size" size="small"></el-input>
          </el-form-item>
        </div>
        <div
          class="flex-item"
          v-if="form.newsType === 'SP' || form.newsType === 'AD_SP'"
        >
          <el-form-item label="资源URL:" prop="sourceURL">
            <el-input v-model="form.sourceURL" size="small" disabled></el-input>
          </el-form-item>

          <el-form-item label="资源ID:" prop="sourceID">
            <el-input v-model="form.sourceID" size="small" disabled></el-input>
          </el-form-item>
          <el-form-item></el-form-item>
        </div>
        <div class="flex-item">
          <el-form-item label="广告跳转连接:" prop="linkUrl">
            <el-input
              type="textarea"
              v-model="form.linkUrl"
              size="small"
            ></el-input>
          </el-form-item>
          <el-form-item></el-form-item>
        </div>
        <div class="flex-item">
          <el-form-item label="视频内容:" prop="linkUrl">
            <el-input
              type="textarea"
              v-model="form.summary"
              placeholder="请输入视频内容"
              size="small"
            ></el-input>
          </el-form-item>
          <el-form-item></el-form-item>
        </div>
        <el-form-item label="标签:">
          <el-input
            type="textarea"
            :rows="3"
            placeholder="内容以“，”号隔开，如“张三，李四”"
            v-model="tagString"
          ></el-input>
        </el-form-item>
        <el-form-item label="文件摘要:" prop="md5">
          <el-input
            type="textarea"
            :rows="3"
            placeholder
            v-model="form.md5"
          ></el-input>
        </el-form-item>
        <el-form-item style="padding-bottom: 25px">
          <el-button
            type="primary"
            size="small"
            :loading="flag"
            @click="submitDate"
            >立即创建</el-button
          >
          <el-button size="small" @click="close()">取消</el-button>
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>

<script>
import {validatorIndex} from "@/utils/validator";
import baseConfig from "@/utils/serverUrlConfig";
import videojs from "video.js";
// import md5 from 'js-md5';
import "videojs-contrib-hls";
import API from "@/api";
import local from "@/utils/localStroage.js";
import { getHlsTechOptions, toHlsSource } from "@/utils/hlsPlayer";

export default {
  data() {
    return {
      trackId: "",
      showUpload: false,
      show: false,
      secondModuleList: [],
      // 封面上传地址
      action: baseConfig.baseServerUrl + "/vid/uploadStatic",
      //图集上传
      actionPics: baseConfig.baseServerUrl + "/vid/uploadStaticBatch",
      // 视频播放地址
      videoBaseUrl: baseConfig.playVideoUrl,
      tagString: "",
      isFree: true,
      flag: false,
      player: "",
      attrs: {
        accept: [
          ".mp4",
          ".qlv",
          ".qsv",
          ".ogg",
          ".flv",
          ".avi",
          ".wmv",
          ".rmvb",
        ], //接受文件类型
      },
      // 表单数据
      form: {
        uid: "",
        title: "",
        newsType: "", //上传文件类型
        tags: [],
        summary: "", // 视频内容
        playTime: "",
        cover: "",
        coverThumb: "",
        seriesCover: [],
        via: "admin",
        subModuleID: "",
        isFree: 0,
        coins: 0,
        size: "",
        mimeType: "",
        sourceURL: "",
        sourceID: "",
        filename: "",
        resolution: "",
        freeArea: false,
        md5: "",
        freeTime: 15,
        location: {
          city: "香港",
        },
      },
      rules: {
        title: [{ required: true, message: "请输入标题", trigger: "blur" }],
        via: [{ message: "请输入视频来源", trigger: "blur" }],
        coins: [
          { required: true, message: "请输入视频定价", trigger: "blur" },
          { validator: validatorIndex, trigger: "blur" },
        ],
        subModuleID: [
          { required: true, message: "主题模块不能为空", trigger: "blur" },
        ],
        mimeType: [{ message: "请输入影片类型", trigger: "blur" }],
        sourceURL: [
          { required: true, message: "请输入资源url", trigger: "blur" },
        ],
        sourceID: [
          { required: true, message: "请输入资源id", trigger: "blur" },
        ],
        filename: [{ message: "请输入文件名", trigger: "blur" }],
        location: {
          city: [
            { required: true, message: "请输入城市名称", trigger: "blur" },
          ],
        },
        uid: [
          { required: true, message: "请输入用户uid", trigger: "blur" },
          { validator: validatorIndex, trigger: "blur" },
        ],
      },
    };
  },
  computed: {
    options() {
      return {
        target: baseConfig.baseServerUrl + "/vid/uploadDotStream", //上传地址
        testChunks: false, //是否开启服务器分片校验
        method: "application/json",
        headers: {
          // 额外请求头
          Authorization: local.get("userInfo")
            ? local.get("userInfo").token
            : "",
        },
        fileParameterName: "upload", //文件名参数，默认为file
        query: this.uploadQuery, //额外参数
        singleFile: true, //单文件上传
        chunkSize: 2048000, //分片大小，默认1M
        simultaneousUploads: 6,
        // 把英文时间转成中文
        parseTimeRemaining: function (timeRemaining, parsedTimeRemaining) {
          return parsedTimeRemaining
            .replace(/\syears?/, "年")
            .replace(/\days?/, "天")
            .replace(/\shours?/, "小时")
            .replace(/\sminutes?/, "分钟")
            .replace(/\sseconds?/, "秒");
        },
      };
    },
  },
  methods: {
    // 提交验证
    submitDate() {
      if (!this.tagString) {
        this.$message.error("标签不能为空！");
        return false;
      }
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.flag = true;
          this.uploadImgsInfo();
        } else {
          return false;
        }
      });
    },
    transformData(originalData) {
      return originalData.map((module) => {
        return {
          value: module.moduleID,
          label: module.moduleName,
          children: module.list
            ? module.list.map((subModule) => {
                return {
                  value: subModule.moduleID,
                  label: subModule.moduleName,
                  children: subModule.subModules
                    ? subModule.subModules.map((item) => {
                        return {
                          value: item.id,
                          label: item.moduleName,
                        };
                      })
                    : null,
                };
              })
            : null,
        };
      });
    },
    getHotModule() {
      const params = {
        pageSize: 20,
        pageNumber: 1,
      };
      API.getModuleList(params).then((res) => {
        this.secondModuleList = this.transformData(res.data);
      });
    },
    // 上传图集信息
    uploadImgsInfo() {
      this.form.tags = this.tagString.split("，");
      API.uploadVideo(this.form)
        .then((res) => {
          if (res.code === 200) {
            this.$message({
              message: "上传帖子成功！",
              type: "success",
            });
            this.$emit("handlerLoadList");
          } else {
            this.$message.error("上传帖子失败！");
          }
          this.flag = false;
          this.close();
        })
        .catch(() => {
          this.flag = false;
          this.close();
        });
    },
    // 上传视频信息
    uploadVideoInfo() {
      this.form.tags = this.tagString.split("，");
      API.uploadVideo(this.form)
        .then((res) => {
          if (res.code === 200) {
            this.$message({
              message: "上传视频信息成功！",
              type: "success",
            });
            this.$emit("handlerLoadList");
          } else {
            this.$message.error("上传视频信息失败！");
          }
          this.flag = false;
          this.close();
        })
        .catch(() => {
          this.flag = false;
          this.close();
        });
    },
    // 监听视频定价价格动态改变是否是免费视频状态
    changeInput() {
      if (this.form.coins > 0) {
        this.isFree = true;
        this.form.isFree = 1;
      } else {
        this.isFree = false;
        this.form.isFree = 0;
      }
    },
    // 封面图上传成功回调
    successCallback(res) {
      this.form.cover = res.data.coverImg;
      this.form.coverThumb = res.data.coverImg;
    },
    // 封面图上传成功回调
    successCallbackPic(seriesCover) {
      this.form.seriesCover = seriesCover;
    },
    //视频上传额外参数
    uploadQuery(file, chunk) {
      return {
        pos: chunk.offset,
        id: String(this.trackId),
        // totalPos:chunk.offset+1,
        // data:data
      };
    },
    //视频上传选中时
    fileAdd() {
      this.generateTaskId();
    },
    //定义视频上传唯一标识符id
    generateTaskId() {
      const time = new Date().getTime();
      this.trackId = time;
    },
    //视频上传成功时回调函数
    // eslint-disable-next-line no-unused-vars
    onFileSuccess(rootFile, file, response, chunk) {
      let res = JSON.parse(response);
      this.form.filename = res.data.filename;
      this.form.size = res.data.size;
      this.form.md5 = res.data.md5;
      this.form.mimeType = res.data.mimeType;
      this.form.sourceID = res.data.sourceID;
      this.form.sourceURL = res.data.sourceURL;
      this.form.resolution = res.data.resolution;
      this.form.playTime = res.data.playTime;
      API.uploadSuccess({ id: res.data.sourceID })
        .then((res) => {
          if (res.code !== 200) {
            this.$message.error("通知失败！");
          }
        })
        .catch(() => {
          this.$message.error("通知异常！");
        });
    },
    handleChangeModule(val) {
      this.form.subModuleID = val;
    },
    // 初始化视频实例
    initPlayer() {
      document.getElementById("video-box").innerHTML =
        '<video id="my-video" class="video-js vjs-default-skin" controls preload="auto" style="width:100%;height:100%"></video>';
      this.player = videojs(
        "my-video",
        {
          bigPlayButton: false,
          textTrackDisplay: false,
          posterImage: true,
          errorDisplay: false,
          controlBar: true,
          ...getHlsTechOptions(),
        },
        function () {
          this.play();
        }
      );
      this.player.src(toHlsSource(this.form.sourceURL));
    },
    // 开启新增弹窗
    open() {
      this.form.cover = "";
      this.show = true;

      this.getHotModule();
    },
    // 标签封面上传成功回掉
    changeImgUrl(data) {
      this.form.cover = data;
      this.form.coverThumb = data;
    },
    // 关闭新增弹窗
    close() {
      this.show = false;
      this.tagString = "";
      this.$refs.form.resetFields();
      if (this.player) {
        this.player.dispose();
      }
    },
  },
};
</script>

<style lang="scss">
.add-video-box {
  width: calc(100% - 0px);
  height: calc(100% - 50px);
  margin-left: -10px;
  background: white;
  position: absolute;
  bottom: 0;
  left: -200px;
  z-index: 10;
  transition: left 0.2s linear;
  .flex-item {
    width: 90%;
    display: flex;
    .el-form-item {
      flex: 1;
    }
  }
  .el-upload .el-upload--picture-card {
    width: 100px;
    height: 100px;
  }
  .el-textarea {
    width: 500px;
  }
  .el-input {
    width: 250px;
  }
  .uploader-drop {
    background: none;
    border-radius: 5px;
    border: none;
    padding: 0;
  }
  .uploader-file {
    border-bottom: 1px dashed #ccc;
  }
  .uploader-btn {
    background: #e63765;
    color: white;
    padding: 5px 10px;
    font-size: 13px;
    border: none;
    border-radius: 3px;
    &:hover {
      background: #eb5f84;
    }
  }
  .title {
    width: 100%;
    height: 30px;
    display: inline-block;
    font-size: 14px;
    line-height: 30px;
    overflow: hidden;
    color: #666;
    margin-bottom: 15px;
    cursor: pointer;
    i {
      &:hover {
        color: #e63765;
      }
    }
    span {
      margin-left: 10px;
    }
  }
  .upload-video {
    width: 300px !important;
    .circle-bar {
      width: 100%;
      height: 100%;
      text-align: center;
      .el-progress-circle {
        margin: 0 auto;
        margin-top: 8px;
      }
    }
    .video-box {
      width: 100%;
      height: 100%;
    }
  }
  .avatar-uploader {
    width: 150px;
    height: 150px;
  }
  .el-upload {
    width: 100%;
    height: 100%;
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
    &:hover {
      border: 1px dashed #e63765;
    }
    img {
      width: 100%;
      height: 100%;
    }
  }
  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 150px;
    height: 150px;
    line-height: 150px;
    text-align: center;
    &:hover {
      color: 1px dashed #e63765 !important;
    }
  }
}
.show {
  left: 20px;
  transition: left 0.2s linear;
}
</style>
